import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "detected"]

  connect() {
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

    // Display detected timezone
    if (this.hasDetectedTarget) {
      this.detectedTarget.textContent = browserTimezone
    }

    // Auto-select the browser's timezone if it's a new record (no value selected yet)
    if (this.hasSelectTarget) {
      const select = this.selectTarget
      const currentValue = select.value

      // If no timezone is set yet, or it's the default, use browser timezone
      if (!currentValue || currentValue === "" || currentValue === "International Date Line West") {
        // Rails time_zone_select uses ActiveSupport::TimeZone names (e.g., "Warsaw")
        // not IANA identifiers (e.g., "Europe/Warsaw")
        // Extract the city name from the timezone (e.g., "Europe/Warsaw" -> "Warsaw")
        const cityName = browserTimezone.split('/').pop()

        const options = Array.from(select.options)
        const matchingOption = options.find(option => option.value === cityName)

        if (matchingOption) {
          matchingOption.selected = true
          select.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    }
  }
}
